<template>
  <v-card id="user-settings-card">
    <!-- tabs -->
    <v-tabs
      v-model="tab"
      show-arrows
      grow
    >
      <v-tab
        v-for="tab in tabs"
        :key="tab.icon"
        @click="getUser"
      >
        <v-icon
          size="20"
          class="me-3"
        >
          {{ tab.icon }}
        </v-icon>
        <span>{{ tab.title }}</span>
      </v-tab>

      <v-tab
        :to="{ name: 'conta' }"
      >
        <v-icon
          color="error"
        >
          {{ icons.mdiCloseCircleOutline }}
        </v-icon>
      </v-tab>
    </v-tabs>

    <!-- tabs item -->
    <v-tabs-items v-model="tab">
      <v-tab-item>
        <cliente-settings-account
          :key="cliente.id"
          :account-data="cliente"
          :acesso-put="acessoPut"
        >
        </cliente-settings-account>
      </v-tab-item>

      <v-tab-item>
        <cliente-settings-security
          :key="cliente.id"
          :security-data="cliente"
          :acesso-put="acessoPut"
        >
        </cliente-settings-security>
      </v-tab-item>

      <v-tab-item>
        <cliente-settings-info
          :key="cliente.id"
          :info-data="cliente"
          :cep="cep"
          :acesso-put="acessoPut"
        >
        </cliente-settings-info>
      </v-tab-item>

      <v-tab-item>
        <cliente-settings-socials
          :key="cliente.id"
          :socials-data="cliente"
          :acesso-put="acessoPut"
        >
        </cliente-settings-socials>
      </v-tab-item>

      <v-tab-item>
        <cliente-settings-notification
          :notification-data="cliente"
          :acesso-put="acessoPut"
        >
        </cliente-settings-notification>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import {
  mdiAccountOutline,
  mdiBellOutline,
  mdiBookmarkOutline,
  mdiInformationOutline,
  mdiLockOpenOutline,
  mdiCloseCircleOutline,
} from '@mdi/js'
import { ref } from '@vue/composition-api'
import { mapState } from 'pinia'

// demos
import ClienteSettingsAccount from '@/views/empresa/EmpresaSettingsAccount.vue'
import ClienteSettingsSecurity from '@/views/empresa/EmpresaSettingsSecurity.vue'
import ClienteSettingsInfo from '@/views/empresa/EmpresaSettingsInfo.vue'
import ClienteSettingsSocials from '@/views/empresa/EmpresaSettingsSocials.vue'
import ClienteSettingsNotification from '@/views/empresa/EmpresaSettingsNotification.vue'
import useAuthStore from '@/store/auth'
import useUserStore from '@/store/user'
import ColaboradorService from '@/services/modules/ColaboradorService'

export default {
  components: {
    ClienteSettingsAccount,
    ClienteSettingsSecurity,
    ClienteSettingsInfo,
    ClienteSettingsSocials,
    ClienteSettingsNotification,
  },

  data() {
    return {
      cliente: {},
      cep: '',
      idPut: 2043,
      acessoPut: true,
    }
  },

  computed: {
    ...mapState(useAuthStore, ['funcionalidades']),
    ...mapState(useUserStore, ['id']),
  },

  mounted() {
    this.getUser()
    // this.permissoes()
  },

  methods: {
    permissoes() {
      if (!this.funcionalidades.includes(this.idPut)) {
        this.acessoPut = false
      }
    },

    async getUser() {
      this.cliente = await ColaboradorService.getById(this.id)
      this.cep = this.cliente.endereco.cep
    },
  },

  setup() {
    const tab = ref('')

    // tabs
    const tabs = [
      { title: 'Conta', icon: mdiAccountOutline },
      { title: 'Segurança', icon: mdiLockOpenOutline },
      { title: 'Informações', icon: mdiInformationOutline },
      { title: 'Redes sociais', icon: mdiBookmarkOutline },
      { title: 'Notificações', icon: mdiBellOutline },
    ]

    // account settings data
    const accountSettingData = {}

    return {
      tab,
      tabs,
      accountSettingData,
      icons: {
        mdiAccountOutline,
        mdiLockOpenOutline,
        mdiInformationOutline,
        mdiBookmarkOutline,
        mdiBellOutline,
        mdiCloseCircleOutline,
      },
    }
  },
}
</script>
